export default __webpack_public_path__ + "static/media/bankdemo-color.9c57fd33.svg";